export const anvilConfig = {
  isLargeWidget: false,
  widgetSize: {
    minWidth: "sizing-9",
  },
};
